(function () {
  // Blocks adding a product until the shipping-timing consent has been selected.
  // The All in gift button lives outside the product form in a React tree, so
  // the guard also watches that product-page button from the capture phase.
  const ROOT = '[data-shipping-consent]';
  const INPUT = '[data-shipping-consent-input]';
  const ERROR = '[data-shipping-consent-error]';
  const ADD_BUTTON = 'button[name="add"]';
  const PRODUCT_FORM = 'form[data-type="add-to-cart-form"]';
  const APP_CHECKOUT_LABEL = '購入手続き';

  function getConsentRoot(target) {
    // The consent block now sits above the All in gift block, outside the
    // product form, so a form-scoped lookup can legitimately come up empty.
    const form = target?.closest?.(PRODUCT_FORM);
    const inForm = form?.querySelector(ROOT);
    if (inForm) return inForm;

    const section = (form || target)?.closest?.('.product__info-container');
    return section?.querySelector(ROOT) || document.querySelector(ROOT);
  }

  function isAddTrigger(target) {
    if (!target || !target.closest) return false;
    if (target.closest(ADD_BUTTON)) return true;

    const appButton = target.closest('chakra-scope button');
    return !!appButton && appButton.textContent.includes(APP_CHECKOUT_LABEL);
  }

  function showError(root) {
    const error = root?.querySelector(ERROR);
    if (!root || !error) return;

    error.hidden = false;
    root.scrollIntoView({ block: 'center', behavior: 'smooth' });
    root.querySelector(INPUT)?.focus({ preventScroll: true });
  }

  function onClick(event) {
    if (!isAddTrigger(event.target)) return;

    const root = getConsentRoot(event.target);
    const input = root?.querySelector(INPUT);
    if (!input || input.checked) return;

    event.preventDefault();
    event.stopPropagation();
    showError(root);
  }

  // Covers submitting the product form with the keyboard or other scripts.
  function onSubmit(event) {
    if (!event.target.matches?.(PRODUCT_FORM)) return;

    const root = getConsentRoot(event.target);
    const input = root?.querySelector(INPUT);
    if (!input || input.checked) return;

    event.preventDefault();
    event.stopPropagation();
    showError(root);
  }

  function onChange(event) {
    if (!event.target.matches?.(INPUT)) return;

    const error = event.target.closest(ROOT)?.querySelector(ERROR);
    if (error) error.hidden = true;
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onChange);
})();
